<template>
  <div class="main-body">
    <div class="header">摄像头</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="openAdd">绑定设备</el-button>

        <div style="float:right">

          <el-input placeholder="输入姓名" v-model="name" clearable style="margin-right:10px;width:120px"></el-input>
          <el-input placeholder="输入手机号" v-model="phone" clearable style="margin-right:10px;width:140px"></el-input>
          <el-input placeholder="输入身份证号" v-model="idCard" clearable style="margin-right:10px;width:200px"></el-input>
          <el-input placeholder="输入SN号" v-model="sn" clearable style="margin-right:10px;width:140px"></el-input>


          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="选择区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:140px;margin-right:10px"></elSelectTree>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">

        <el-table-column prop="userName" label="用户姓名"></el-table-column>

        <el-table-column prop="phone" label="手机号"></el-table-column>

        <el-table-column prop="sn" label="序列号（SN）"></el-table-column>

        <el-table-column prop="bindTime" label="绑定时间" :formatter="timefilter"></el-table-column>

        <el-table-column fixed="right" label="操作" width="400">
          <template slot-scope="scope">

<!--                <el-button type="success" size="small"  @click="openCamera(scope.$index, scope.row)">查看监控</el-button>-->
<!--                <el-button type="danger" size="small" @click="RemoveBinding(scope.row)">解绑</el-button>-->


            <el-button type="success" size="mini"  @click="viewCamera(scope.$index, scope.row)">视频预览</el-button>
            <el-button type="success" size="mini"  @click="viewCameraPlus(scope.$index, scope.row)">视频对讲</el-button>
            <el-button type="success" size="mini"  @click="viewCameraPlusBack(scope.$index, scope.row)">视频回放</el-button>
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>

          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showAdd" v-on:closeAdd="closeAdd"  v-on:getList="getList"></Add>
    <ViewCamera ref="myViewCamera" v-show="showCamera" v-on:closeCamera="closeCamera"></ViewCamera>
    <ViewCameraPlus ref="myViewCameraPlus" v-show="showCameraPlus" v-on:closeCameraPlus="closeCameraPlus"></ViewCameraPlus>
    <ViewCameraPlusBack ref="myViewCameraPlusBack" v-show="showCameraPlusBack" v-on:closeCameraPlusBack="closeCameraPlusBack"></ViewCameraPlusBack>

  </div>
</template>

<script>

import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "../Comm/Add"
import ViewCamera from "../Comm/ViewCamera";
import ViewCameraPlus from "../Comm/ViewCameraPlus";
import ViewCameraPlusBack from "../Comm/ViewCameraPlusBack";
import elSelectTree from "@/components/ElSelectTree"


export default {
  name: "Page",
  data() {
    return {
      tableLoading:false,

      showAdd:false,
      showCamera:false,
      showCameraPlus:false,
      showCameraPlusBack:false,

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      name:"",
      phone: "",
      sn: "",
      idCard:'',

      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      zoneValue: [],
      zoneCode: '',

    };
  },
  components: {Add,ViewCamera,elSelectTree,ViewCameraPlus,ViewCameraPlusBack},
  created() {
    this.th = this.$store.state.tableHeight;
    this.getZone();
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    openAdd: function () {
      this.showAdd = !this.showAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showAdd = !this.showAdd;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },




    viewCamera(index,row){
      this.$refs.myViewCamera.init(row.sn,row.deviceCameraCode);
      this.showCamera =!this.showCamera;
    },
    viewCameraPlus(index,row){
      this.$refs.myViewCameraPlus.init2(row.sn,row.deviceCameraCode,row.yzm,row.tdh);
      this.showCameraPlus =!this.showCameraPlus;
    },
    viewCameraPlusBack(index,row){
      this.$refs.myViewCameraPlusBack.init2(row.sn,row.deviceCameraCode,row.yzm,row.tdh);
      this.showCameraPlusBack =!this.showCameraPlusBack;
    },


    closeCamera(){
      this.showCamera =!this.showCamera;
    },
    closeCameraPlus(){
      this.showCameraPlus =!this.showCameraPlus;
    },
    closeCameraPlusBack(){
      this.showCameraPlusBack =!this.showCameraPlusBack;
    },

    getZoneValue(val) {
      this.zoneCode = val
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/PageByZoneCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          phone: this.phone,
          sn: this.sn,
          name:this.name,
          idCard:this.idCard,
          zoneCode:this.zoneCode,

        },
      }).then((response) => {
        //console.log(response.data.data);

        this.tableLoading=false
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },


    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceCamera/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceCameraCode: row.deviceCameraCode,
          },
        }).then((response) => {
          //console.log(response);

          if (response.data.error == 0) {
            this.$message({message: "解绑成功", type: "success",});
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }

        }).catch(function (error) {
          console.log(error);
        });


      }).catch(() => {
        this.$message({type: "info", message: "已取消解绑",});
      });

    },


    getZone(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);

          //console.log(data.replace(/"listZoneDTO":\[\],/g, ''));

          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
          this.zoneCode = data[0].zoneCode;

          this.getList();

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },



  },
};
</script>

<style scoped>

</style>
